module.exports = __webpack_public_path__ + "img/global__minus.80003738.svg";